import { useContext, useEffect } from 'react';
import { AuthContext } from '../../contexts/AuthContext.jsx';
import { useNavigate, Outlet } from "react-router-dom";
import Loader from '../../components/Loader/Loader'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/login');
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <Loader
        showLoader={isLoading}
        message="Verifying your session, please wait..."
        customStyles={{ top: '50%' }}
      />
    );
  }

  if (isAuthenticated) {
    return children;
  }

  return null;
};

export default ProtectedRoute;
